import { api } from './client'

export const uploadImport = async (entity, file, options = {}) => {
  const form = new FormData()
  form.append('file', file)
  const { data } = await api.post(`/import/${entity}`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: options.onUploadProgress,
  })
  return data
}

export const previewProductsImport = async (file) => {
  const form = new FormData()
  form.append('file', file)
  const { data } = await api.post('/import/products/preview', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return data
}
